import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";

import ToasterWrapper from "@/react/components/ToasterWrapper";
const { toast } = ToasterWrapper;

import { useTopicsProvider } from "./Context";
import { Editor } from "./components";
import FloatingPanel from "./components/FloatingPanel";

import { createThreadMarker, destroyThreadMarker } from "./components/FloatingPanel";

import { useCreateThreadWithComment } from "./hooks";


export default function CreateNewThread() {
	const topicsInstance = useTopicsProvider();
	const [createThreadEvent, setCreateThreadEvent] = useState(null);

	useEffect(() => {
		// Subscribe to create thread events
		const unsubscribe = topicsInstance.subscribeToCreateThread((event) => {
			setCreateThreadEvent(event);
		});
		return unsubscribe;
	}, [topicsInstance]);

	const attachedTo = createThreadEvent?.attachedTo;
	const title = createThreadEvent?.title;
	const selector = createThreadEvent?.selector;

	const [createThread, isPending] = useCreateThreadWithComment({
		onSuccess: (data) => {
			topicsInstance.addThreadWithCommentToStore(data);
		}
	});

	useEffect(() => {
		if (attachedTo) createThreadMarker({
			attachedTo
		});

		return () => attachedTo && destroyThreadMarker(attachedTo);
	}, [attachedTo]);

	const handleCreateThreadWithComment = async props => {
		toast.promise(
			createThread({ thread: { title, selector }, commentProps: props }),
			{
				loading: `Creating thread...`,
				success: x => {
					topicsInstance.closeCreateThread();

					setTimeout(() => {
						const attachedEl = document.querySelector(x.selector);
						attachedEl?.querySelector(`.thread-shape`)?.click();
					}, 500);

					return 'Thread created successfully!';
				},
				error: x => x.toString() || 'Failed to create thread.',
			}
		);
	};

	const onClose = () => {
		topicsInstance.closeCreateThread();
	};

	return (
		<FloatingPanel width={400} panelKey={'create-thread ' + attachedTo?.dataset.columnUuid} attachedTo={attachedTo}>
			<div className={"relative flex flex-col gap-2 items-stretch" + (isPending && "thread-comment-loading")}>
				<div className="flex items-start">
					<span className="text-grey-text">{title}</span>
					<button
						className="btn bg-transparent text-primary btn-icon ml-auto text-2xl h-6"
						onClick={onClose}
					>
						close
					</button>
				</div>
				<div className="w-full h-full shrink-0 grow flex flex-col">
					<Editor
						clearSubmission={false}
						onSubmit={handleCreateThreadWithComment}
						placeholder="Create a new thread"
						focus
					/>
				</div>
			</div>
		</FloatingPanel>
	)
}